import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig"; // Ensure this config is correct

const msalInstance = new PublicClientApplication(msalConfig);

// Explicitly call initialize() and export a Promise for proper initialization
const initializeMsal = async () => {
    await msalInstance.initialize();
    return msalInstance;
};

export { msalInstance, initializeMsal };
